import * as React from 'react';
import {
  ClubDetail,
  ClubSocialDetail,
  ClubDetailActionType,
  ClubSocialDetailPropType,
} from '@nls-2022/nls-bll';
import {ApiError} from '@nls-2022/nls-bll';
import {
  flipClubSocialActive,
  ClubBasicSocialDetailApi,
  ClubSocialActiveApi,
} from '@nls-2022/nls-api';
/* 
export type ClubDetail = {
  clubId: number;
  clubName: string;
  clubAddress: string;
  clubLogo: string | null;
  clubUrl: string;
}; */

const ClubSocialsDetail = ({
  clubSocials,
  dispatch,
}: ClubSocialDetailPropType): JSX.Element => {
  const handleFlipSocialActive = (ev: any, param: any) => {
    //setSelectedPyramidId(parseInt(ev.target.dataset.pyramidid));
    //context.dispatchPyramidDetail({
    //  type: PyramidDetailsActionType.PyramidDetailsSelected,
    //  actionPayload: {
    //    pyramidId: parseInt(ev.target.dataset.pyramidid),
    //  },
    //});
    try {
      //let clubDetail = addClub(data);
      let data: ClubSocialActiveApi = {ClubSocialID: param, fluentErrors: []};
      flipClubSocialActive(data).then(clubDetail => {
        if (clubDetail!.fluentErrors?.length > 0) {
          //setFormErrors(clubDetail!.fluentErrors);
        } else {
          //setFormErrors([]);
          dispatch!({
            type: ClubDetailActionType.ClubSocialActiveFlip,
            socialId: param,
          });
        }
      });
    } catch {}
  };
  //console.dir(clubSocials);
  return (
    <ul data-testid="clubsocials">
      {clubSocials?.map(clubSocial => (
        <li className="" key={clubSocial.ClubSocialID}>
          ({clubSocial.SocialName})
          <button
            onClick={event =>
              handleFlipSocialActive(event, clubSocial.ClubSocialID)
            }
            data-socialid={clubSocial.ClubSocialID}
          >
            {clubSocial.Active ? 'active' : 'inactive'}
          </button>
        </li>
      ))}
    </ul>
  );
};

export default ClubSocialsDetail;
